import React, { useState, useEffect } from "react";
//import TituloCard from "../../atoms/titles/Titulo";
import "./cardNoResumen.scss";
import ConsultaIRPF from "../modals/consultaIRPF/ConsultaIRPF";
import Logo from "../../../resources/img/icono-publicaciones.png";

const IRPFNoResumen = () => {
  const [show, setShow] = useState({ nomina: false, mensaje: false });

  const handleShow = (e) => {
    setShow(e);
  };
  const handleClose = (e) => {
    setShow(false);
  };
  useEffect(() => { }, []);

  return (
    <section className="temas">
      <div className="card-caja-mini temas card m-4 h-auto"
        onClick={() => handleShow({ irpf: true })}
        tabIndex={0}
        title="IRPF"
        aria-label="IRPF"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            handleShow({ irpf: true })
          }
        }}
        >

        <div className="tituloAccesibilidad d-flex align-items-center">
          <img

            alt="IRPF"
            src={Logo}
          />
          <h3 className="tituloAccesibilidad ms-2">IRPF</h3>
        </div>

        <span className="mx-4 card-text bot-text">Últimos IRPF disponibles para consultar.</span>

      </div>
      {show.irpf ? (
        <ConsultaIRPF show={show} handleClose={handleClose}></ConsultaIRPF>
      ) : null}
    </section>


  );
};
export default IRPFNoResumen;
